// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2910":"db8304cf","3491":"9434c7a7","6067":"9d94453c","6625":"db8304cf","9131":"9434c7a7"}[chunkId] + ".chunk.css";
};